import { SentProformaEmployeeCostReportDTO } from "src/models/sent-proforma-employee-cost-report/sent-proforma-employee-cost-report-dto";
import { SentProformaEmployeeCostReportSTO } from "src/models/sent-proforma-employee-cost-report/sent-proforma-employee-cost-report-sto";
import { BaseApiService } from "../base";

export class SendProformaEmployeeCostReportApiService extends BaseApiService<
  SentProformaEmployeeCostReportDTO,
  SentProformaEmployeeCostReportSTO
> {
  constructor() {
    super({
      servicePath: "/SentProformaEmployeeCostReport",
      loadItemsPath: "/GetSentProformaEmployeeCostReports",
      saveItemsPath: "/SendProformaEmployeeCostReport",
    });
  }
}
